import { h } from './index-16dc7dde.js';

const Se360widget = ({ uri, scale }) => {
  const props = {
    uri,
    scale,
  };
  return (h("se-360-widget", Object.assign({}, props, { speed: "100", "auto-spin": "false", "auto-spin-speed": "3600", zoom: "2", language: "en", "enable-banner": "false", "enable-fullscreen": "false", "enable-zoom": "false", className: "hydrated" })));
};
const Se3dWidget = ({ uri }) => {
  const props = {
    uri,
  };
  return (h("se-3d-widget", Object.assign({}, props, { "auto-spin": "false", "auto-spin-speed": "20000", "stop-auto-spin-on-rotate": "true", language: "en", "enable-banner": "false", "enable-fullscreen": "false" })));
};

export { Se360widget as S, Se3dWidget as a };
